import { useErrorHandler, useExperiments, useHttpClient } from '@wix/fe-essentials/react';
import { useQuery } from '@wix/fe-essentials/react-query/react';
import { queryRuleExecutionResults } from '../api/query-rule-execution-results';
import { SITE_LEVEL_PAGE_ID } from '../consts';
import { AnalysisState, usePanelStateAtom } from '../hooks/rules-state';
import { useA11yWizardAdapter } from '../hooks/use-a11y-wizard-adapter';
import { useSessionInfoContext } from '../hooks/use-session-info-context';
import { isStaticPage } from '../rule-mappers/shared/helpers';
import { QueryId } from './types';
export const useQueryRuleExecutionResultsQuery = (pageId, showFailedFetchRuleExecutionResultsModalWrapper) => {
  const httpClient = useHttpClient();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const errorHandler = useErrorHandler();
  const {
    getGroupData,
    setGroupExecutionResults,
    setGroupData
  } = usePanelStateAtom();
  const {
    analysisState,
    analysisData
  } = getGroupData(pageId ?? '') ?? {};
  const itemType = (analysisData == null ? void 0 : analysisData.itemType) ?? (pageId === SITE_LEVEL_PAGE_ID ? 'SITE_LEVEL' : '');
  const {
    experiments
  } = useExperiments();
  const useNewRuleGroupList = experiments.enabled('specs.responsive-editor.RefactorGroupList');
  const {
    branchId
  } = useSessionInfoContext();
  return useQuery({
    enabled: useNewRuleGroupList || capabilities.compactPanelChrome ? false : Boolean(pageId) && (isStaticPage(itemType) || pageId === SITE_LEVEL_PAGE_ID) && analysisState === AnalysisState.AnalyzeDonePendingResults,
    onError: error => {
      showFailedFetchRuleExecutionResultsModalWrapper(error);
      setGroupData(pageId ?? '', {
        analysisState: AnalysisState.AnalyzeDoneFailedToFetchResults
      });
    },
    onSuccess: ruleExecutionResults => {
      setGroupExecutionResults(pageId ?? '', ruleExecutionResults);
    },
    queryFn: async () => {
      const id = pageId === SITE_LEVEL_PAGE_ID ? 'SITE_LEVEL' : pageId ?? '';
      const pageRuleExecutionResults = await queryRuleExecutionResults(httpClient, errorHandler, itemType, id, branchId ?? undefined);
      return pageRuleExecutionResults;
    },
    queryKey: [QueryId.QueryRuleExecutionResults, itemType, pageId],
    refetchOnWindowFocus: false,
    retry: false
  });
};
//# sourceMappingURL=use-query-rule-execution-results-query.js.map